import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import { CapaQuotationServiceType } from '@generated/graphql';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { requestEnumToString } from '@utils/enumToString';
import useQueryString from '@hooks/useQueryString';
import {
  DesignRequestStageEnum,
  PcbRequestStageEnum,
  RequestQueryString
} from '../../types';

interface ServiceTypeCardProps {
  id: CapaQuotationServiceType | 'SURVEY';
  src: string;
  serviceName: string;
}

const ServiceTypeCardMobile: React.FC<ServiceTypeCardProps> = ({ id, src }) => {
  const { onAddQueryString } = useQueryString<RequestQueryString>();
  const { card } = useServiceTypeCardStyles({
    src
  });

  const onClick = useCallback(
    (e) => {
      onAddQueryString({
        serviceType: id as CapaQuotationServiceType,
        stage:
          id === CapaQuotationServiceType.Pcb
            ? PcbRequestStageEnum.PROCESS_SELECT
            : id === CapaQuotationServiceType.Design
            ? DesignRequestStageEnum.PROCESS_SELECT
            : undefined
      });
    },
    [id, onAddQueryString]
  );

  return (
    <button className={`${card} `} onClick={onClick}>
      <CustomizedTypography variant="subtitle1" fontWeight="500">
        <i className="request-gtm-serviceType-btn">
          {requestEnumToString(id as CapaQuotationServiceType)}
        </i>
      </CustomizedTypography>
      <img src={src} width={64} height={64} alt={id} />
    </button>
  );
};

export default ServiceTypeCardMobile;

const useServiceTypeCardStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    padding: '0px 20px',
    width: '100%',
    minHeight: 80,
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '16px',
    border: `1px solid ${colorSet.gray400}`,
    backgroundColor: colorSet.gray000,
    '& img': {
      borderRadius: '8px',
      objectFit: 'cover'
    }
  }
}));
